import { useEffect } from "react";
import PropTypes from "prop-types";

import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import SuccessIcon from "assets/svg/form-success.svg";

import styles from "./styles.module.css";

const SuccessStep = ({ isProjectRadar, project, projectDetailFormData, isProjectDetailSticky }) => {
  useEffect(() => {
    if (isProjectRadar) {
      const gtmLabel = {
        project_name: project?.project?.project_name,
        project_company_name: project?.company?.project_company_name,
        city: project?.city?.city,
        town: project?.town?.town,
      };
      setTimeout(() => {
        Ga4WithEventParameters(
          {
            eventName: "proje_radari_bilgi",
            eventParameters: gtmLabel,
          },
          300
        );
      });
    }
  }, []);
  return (
    <div className={styles.successContainer}>
      <SuccessIcon className={styles.successIcon} />
      {isProjectRadar ? (
        <>
          <p className={styles.successTitle}>Form Bilgilerinizi Gönderdik</p>
          <p className={styles.successText}>En kısa sürede size dönüş sağlayacağız.</p>
        </>
      ) : (
        (projectDetailFormData || isProjectDetailSticky) && (
          <>
            <p className={styles.successTitle}>Form Başarıyla İletildi</p>
            <p className={styles.successText}>Bilgilerinizi aldık, en kısa zamanda size ulaşacağız.</p>
          </>
        )
      )}
    </div>
  );
};

SuccessStep.propTypes = {
  isProjectRadar: PropTypes.bool,
  projectDetailFormData: PropTypes.string,
  isProjectDetailSticky: PropTypes.bool,
  project: PropTypes.object,
};

export default SuccessStep;
